import { Checkbox, Typography } from "@suraasa/placebo-ui"
import { Answer as AnswerType } from "api/resources/assessments/types"
import clsx from "clsx"

import styles from "./MultipleCorrect.module.css"

type Props = {
  question: AnswerType
}

function MultipleCorrect({ question }: Props) {
  return (
    <>
      <div>
        <Typography variant="body" className="mb-2 mt-1">
          {question.question}
        </Typography>
      </div>
      <div className="mt-2">
        <div>
          {Object.entries(question.options).map(([optionId, optionText]) => {
            const id = parseInt(optionId)
            const markedOptionIndex =
              question.response && question.response.indexOf(id)

            const correctOptionIndex = question.correctAnswer.indexOf(id)

            const isCorrect =
              markedOptionIndex !== null &&
              markedOptionIndex !== -1 &&
              correctOptionIndex !== -1
            const isMarked = question.response && markedOptionIndex !== -1

            return (
              <div key={optionId} className={styles.checkbox}>
                <Checkbox
                  containerClass={clsx("my-1 w-full rounded-lg", {
                    [styles.correctAnswer]: isCorrect,
                    [styles.markedAnswer]: !isCorrect && isMarked,
                  })}
                  color={isCorrect ? "success" : "critical"}
                  checked={isCorrect || Boolean(isMarked)}
                  readOnly
                  label={optionText}
                />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default MultipleCorrect
